import { FIND_PARENT, FIND_USER } from "../../routes";
import { IFindUserInformation } from "../../../types/common.interface";
import customAxios from "../../customAxios";
import utils from "../../../utils";

async function findParent(props: IFindUserInformation) {
  var thisUrl = FIND_PARENT;

  let body: any = {
    userType: "PASSENGER",
    page: props.page,
    limit: props.limit,
    populate: "blocks gender parentInformation.province parentInformation.city",
  };

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                            Searching For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  if (props?.search?.value) {
    body = {
      ...body,
      search: {
        searchMode: props?.search?.base,
        searchValue: props?.search?.value,
      },
      // [String(props.search.base)]: utils.convertNumbers2English(
      //   props.search.value
      // ),
    };
  }

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                                    Filtering For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------
  if (props?.filters) {
    const { province, city, gender } = props.filters;
    body = {
      ...body,
      "parentInformation.province": province?._id,
      "parentInformation.city": city?._id,
      gender: gender?.value,
    };
  }

  // ?? Academic year (سال تحصیلی) scope, set last so the branches above cannot drop it.
  if (props.academicYear) body.academicYear = props.academicYear;

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ GET_ALL_COMPANY: error });
  }
}

export default findParent;
